// src/components/profile/UserListItem.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import '../../styles/user-list-item.css';

const UserListItem = ({ user, currentUsername }) => {
  const [isFollowing, setIsFollowing] = useState(user.isFollowing);
  const [loading, setLoading] = useState(false);
  
  const handleFollowToggle = async (e) => {
    e.preventDefault(); // Prevent navigation
    
    if (user.username === currentUsername) return;
    
    setLoading(true);
    
    try {
      if (isFollowing) {
        await api.delete(`/api/follows/${user.username}`);
      } else {
        await api.post(`/api/follows/${user.username}`);
      }
      
      setIsFollowing(!isFollowing);
    } catch (err) {
      console.error('Error toggling follow:', err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="user-list-item">
      <Link to={`/profile/${user.username}`} className="user-list-link">
        <img 
          src={user.profilePic 
            ? (user.profilePic.startsWith('ipfs://') 
              ? `https://ipfs.io/ipfs/${user.profilePic.replace('ipfs://', '')}` 
              : user.profilePic)
            : '/default-avatar.png'} 
          alt={user.username}
          className="user-list-avatar"
        />
        <div className="user-list-info">
          <h3 className="user-list-name">{user.displayName || user.username}</h3>
          <span className="user-list-username">@{user.username}</span>
          {user.bio && <p className="user-list-bio">{user.bio}</p>}
        </div>
      </Link>
      
      {user.username !== currentUsername && (
        <button 
          className={`follow-button ${isFollowing ? 'following' : ''}`}
          onClick={handleFollowToggle}
          disabled={loading}
        >
          {loading ? '...' : isFollowing ? 'Following' : 'Follow'}
        </button>
      )}
    </div>
  );
};

export default UserListItem;